import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-20 bg-gray-900 text-white" data-id="element-233">
      <div className="max-w-5xl mx-auto px-4" data-id="element-234">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-235">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-236">
            <h3 className="text-2xl font-serif font-bold text-red-400 mb-6 border-b border-gray-700 pb-4" data-id="element-237">
              Antes de leer:
            </h3>
            <ul className="space-y-4" data-id="element-238">
              {['todo está mezclado', 'pensás demasiado', 'sentís culpa por sentir', 'te exigís estar bien'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-300" data-id="element-239">
                  <X className="text-red-500 w-5 h-5 flex-shrink-0" data-id="element-240" />
                  <span data-id="element-241">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white text-gray-900 p-8 rounded-xl shadow-2xl transform md:-translate-y-4 border-t-4 border-green-500" data-id="element-242">
            <h3 className="text-2xl font-serif font-bold text-green-700 mb-6 border-b border-gray-200 pb-4" data-id="element-243">
              Después de leer:
            </h3>
            <ul className="space-y-4" data-id="element-244">
              {['entendés mejor lo que te pasa', 'bajás un cambio', 'dejás de pelearte con lo que sentís', 'recuperás calma interna'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-245">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-246">
                    <Check className="text-green-600 w-4 h-4 flex-shrink-0" strokeWidth={3} data-id="element-247" />
                  </div>
                  <span data-id="element-248">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16 max-w-2xl mx-auto" data-id="element-249">
          <p className="text-2xl md:text-3xl font-serif italic text-gray-300" data-id="element-250">
            “No porque cambió el mundo. <br className="md:hidden" data-id="element-251" />
            <span className="text-white font-bold not-italic" data-id="element-252">
              Porque te acomodaste vos.
            </span>
            ”
          </p>
        </motion.div>
      </div>
    </section>;
}